module.exports = __webpack_public_path__ + "static/img/icon_fanhui2x.5578825.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/dynamicForm/icon_fanhui2x.png
// module id = FcDN
// module chunks = 0